import { render, staticRenderFns } from "./EmailTransferSummary.vue?vue&type=template&id=2b42527c&scoped=true&"
import script from "./EmailTransferSummary.vue?vue&type=script&lang=ts&"
export * from "./EmailTransferSummary.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTransferSummary.vue?vue&type=style&index=0&id=2b42527c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b42527c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
